export default __webpack_public_path__ + "static/media/plain.fbdc136e.png";